<template>
  <div class="app-container">
    <div class="search-bar">
      <div class="search-left">
        <label class="search-label">问题名称</label>
        <el-input v-model="form.name" class="search-input" placeholder="请输入需要查询的问题名称" />
      </div>
      <div class="search-right">
        <el-button class="query-btn" @click="fetchData">查询</el-button>
        <el-button type="primary" @click="showAddDialog">新增</el-button>
        <el-button type="primary" @click="showImportDialog">导入</el-button>
      </div>
    </div>
    <el-table
      ref="table"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      height="calc(100vh - 200px)"
      border=""
      :header-cell-style="{background:'rgb(244 244 244)'}"
      :empty-text="'暂无数据'"
    >
      <el-table-column align="center" label="问题" min-width="180" fixed="left">
        <template slot-scope="scope">
          {{ scope.row.question }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="答案" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.answer }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" min-width="180">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300" fixed="right">
        <template slot-scope="scope">
          <el-button @click="editItem(scope.row)">编辑</el-button>
          <el-button @click="delItem(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增问题弹窗 -->
    <el-dialog :visible.sync="addDialogVisible" width="75%" :show-close="false" :close-on-click-modal="false">
      <div class="custom-dialog">
        <el-form ref="ruleForm" :model="qaForm" label-width="100px">
          <el-form-item label="问题">
            <el-input v-model="qaForm.question" type="textarea" />
          </el-form-item>
          <el-form-item label="答案">
            <el-input v-model="qaForm.answer" type="textarea" />
          </el-form-item>
          <el-form-item label="问题意图">
            <el-input v-model="qaForm.questionIntent" type="textarea" />
          </el-form-item>
          <el-form-item label="答案意图">
            <el-input v-model="qaForm.answerIntent" type="textarea" />
          </el-form-item>
        </el-form>
        <div class="task-check">
          <div class="check-name">检查点</div>
          <div class="custom-check">
            <div v-for="(check, c_i) in qaForm.checkList" :key="c_i">
              <el-input v-model="qaForm.checkList[c_i]" type="textarea" :rows="2" />
              <i class="el-icon-circle-plus-outline" @click="addCheck" />
              <i
                v-if="qaForm.checkList.length > 1"
                class="el-icon-remove-outline"
                @click="qaForm.checkList.splice(c_i, 1)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="custom-btn">
        <el-button @click="closeAddDialog()">取消</el-button>
        <el-button type="primary" @click="confirmAdd()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 导入弹窗 -->
    <el-dialog
      :visible.sync="importDialogVisible"
      width="70%"
      top="10vh"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <!-- 第一步：选择资源 -->
      <div v-if="importStep === 1" class="mode-dialog">
        <div class="form-item">
          <div class="item-name">选择资源</div>
          <el-select
            v-model="currentResource"
            style="margin-left: -6px;"
            placeholder="请选择资源"
            value-key="id"
            @change="changeResource"
          >
            <el-option v-for="resource in resourceList" :key="resource.id" :label="resource.name" :value="resource" />
          </el-select>
        </div>
        <div class="form-item task-select">
          <div class="item-name">全选</div>
          <el-switch v-model="allTask" active-color="#419eee" @change="selectAllTask" />
        </div>
        <div class="dialog-content">
          <div class="mode-content">
            <el-collapse>
              <el-collapse-item v-for="(task, index) in taskList" :key="task.id">
                <template slot="title">
                  <el-checkbox v-model="task.checked" @change="selectTask(index)">{{ task.question || task.name }}
                  </el-checkbox>
                </template>
                <div class="tast-detail">
                  <div class="question-content">
                    <div class="content-item text">
                      <div>问题： {{ task.question }}</div>
                      <div>答案： {{ task.answer }}</div>
                    </div>
                    <div class="content-item">
                      <div>问题意图： {{ task.questionIntent }}</div>
                      <div>答案意图： {{ task.answerIntent }}</div>
                    </div>
                  </div>
                  <div class="check-list">
                    <div>检查点：</div>
                    <div v-for="(item, index) in task.checkPoints" :key="index">
                      <span>{{ item }}</span>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="dialog-footer">
          <el-button @click="importDialogVisible = false">取消</el-button>
          <el-button type="primary" :disabled="!hasSelectedTask" @click="nextStep">下一步</el-button>
        </div>
      </div>

      <!-- 第二步：确认导入 -->
      <div v-if="importStep === 2" class="mode-dialog">
        <div class="form-item">
          <div class="item-name">导入预览</div>
        </div>
        <div class="dialog-content">
          <div class="select-list">
            <div
              v-for="(item, task_index) in selectedTasks"
              :key="task_index"
              class="list-item"
              :style="{ background: selectTaskIndex === task_index ? '#ecf5ff' : '' }"
            >
              <div @click="editTask(item, task_index)">
                <span>{{ item.question || item.name }}</span>
                <div v-if="item.checkPoints && item.checkPoints.length > 0" class="check-points-preview">
                  <div v-for="(checkPoint, idx) in item.checkPoints" :key="idx" class="check-point-item">
                    <span>检查点{{ idx + 1 }}：{{ checkPoint }}</span>
                  </div>
                </div>
              </div>
              <i class="el-icon-close close-icon" @click="removeSelectedTask(task_index)" />
            </div>
          </div>
          <div v-if="showTaskContent" class="tast-detail task-margin">
            <el-form ref="ruleForm" :model="taskContent" label-width="100px">
              <el-form-item label="问题">
                <el-input v-model="taskContent.question" type="textarea" />
              </el-form-item>
              <el-form-item label="答案">
                <el-input v-model="taskContent.answer" type="textarea" />
              </el-form-item>
              <el-form-item label="问题意图">
                <el-input v-model="taskContent.questionIntent" type="textarea" />
              </el-form-item>
              <el-form-item label="答案意图">
                <el-input v-model="taskContent.answerIntent" type="textarea" />
              </el-form-item>
            </el-form>
            <div class="task-check">
              <div class="check-name">检查点</div>
              <div class="custom-check">
                <div v-for="(check, c_i) in taskContent.checkList" :key="c_i">
                  <el-input v-model="taskContent.checkList[c_i]" type="textarea" :rows="2" />
                  <i class="el-icon-circle-plus-outline" @click="addCheckPoint" />
                  <i
                    v-if="taskContent.checkList.length > 1"
                    class="el-icon-remove-outline"
                    @click="taskContent.checkList.splice(c_i, 1)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <el-button @click="prevStep">上一步</el-button>
          <el-button type="primary" @click="confirmImport">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryQA, qaAdd, qaUpdate, qaDel, sourceTaskList, sourceQuestionList, storyqaBatchAdd } from '@/api/exercise'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      storyId: null,
      list: [],
      listLoading: false,
      addDialogVisible: false,
      form: {
        name: ''
      },
      qaForm: {
        question: '',
        answer: '',
        questionIntent: '',
        answerIntent: '',
        checkList: ['']
      },
      // 导入相关
      importDialogVisible: false,
      importStep: 1,
      resourceList: [],
      currentResource: null,
      taskList: [],
      allTask: false,
      selectedTasks: [],
      selectTaskIndex: -1,
      showTaskContent: false,
      taskContent: {
        question: '',
        answer: '',
        questionIntent: '',
        answerIntent: '',
        checkList: ['']
      }
    }
  },
  computed: {
    hasSelectedTask() {
      return this.taskList.some(task => task.checked)
    }
  },
  created() {
    this.storyId = this.$route.query.storyId
    if (this.storyId) {
      this.fetchData()
    }
  },
  methods: {
    formatDateTime(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    fetchData() {
      this.listLoading = true
      const params = {
        page: 1,
        pageSize: 99,
        storyId: this.storyId,
        name: this.form.name
      }
      queryQA(params).then(response => {
        const records = response.data.records || []
        records.forEach(res => {
          res.createTime = dayjs(res.createTime).format('YYYY-MM-DD HH:mm:ss')
        })
        this.list = records
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    showAddDialog() {
      this.qaForm = {
        id: null,
        question: '',
        answer: '',
        questionIntent: '',
        answerIntent: '',
        checkList: ['']
      }
      this.addDialogVisible = true
    },
    editItem(row) {
      this.qaForm = {
        id: row.id,
        question: row.question || '',
        answer: row.answer || '',
        questionIntent: row.questionIntent || '',
        answerIntent: row.answerIntent || '',
        checkList: row.checkPoints && row.checkPoints.length > 0 ? [...row.checkPoints] : ['']
      }
      this.addDialogVisible = true
    },
    closeAddDialog() {
      this.addDialogVisible = false
    },
    addCheck() {
      this.qaForm.checkList.push('')
    },
    confirmAdd() {
      if (!this.qaForm.question) {
        this.$message({
          message: '请输入问题',
          type: 'error',
          duration: 2 * 1000
        })
        return
      }
      const params = {
        storyId: this.storyId,
        question: this.qaForm.question,
        answer: this.qaForm.answer,
        questionIntent: this.qaForm.questionIntent,
        answerIntent: this.qaForm.answerIntent,
        checkPoints: this.qaForm.checkList.filter(item => item.trim())
      }
      const apiFunc = this.qaForm.id ? qaUpdate : qaAdd
      const successMsg = this.qaForm.id ? '更新成功' : '新增成功'
      const errorMsg = this.qaForm.id ? '更新失败' : '新增失败'
      if (this.qaForm.id) {
        params.id = this.qaForm.id
      }
      apiFunc(params).then(() => {
        this.$message({
          type: 'success',
          message: successMsg,
          duration: 2 * 1000
        })
        this.addDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: errorMsg,
          duration: 2 * 1000
        })
      })
    },
    delItem(id) {
      this.$confirm('此操作将删除该问题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        qaDel({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
            duration: 2 * 1000
          })
          this.fetchData()
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败',
            duration: 2 * 1000
          })
        })
      })
    },
    // 导入相关方法
    showImportDialog() {
      this.importStep = 1
      this.currentResource = null
      this.taskList = []
      this.allTask = false
      this.selectedTasks = []
      this.selectTaskIndex = -1
      this.showTaskContent = false
      this.taskContent = {
        question: '',
        answer: '',
        questionIntent: '',
        answerIntent: '',
        checkList: ['']
      }
      this.importDialogVisible = true
      this.loadResourceList()
    },
    loadResourceList() {
      sourceTaskList({}).then(res => {
        this.resourceList = res.data || []
      })
    },
    changeResource(resource) {
      if (resource && resource.id) {
        sourceQuestionList({ taskId: resource.id }).then(res => {
          this.taskList = (res.data || []).map(task => {
            // 如果这个任务已经在 selectedTasks 中，保持 checked 为 true
            const isSelected = this.selectedTasks.some(selected => selected.id === task.id)
            return {
              ...task,
              checked: isSelected
            }
          })
          // 更新全选状态
          this.allTask = this.taskList.length > 0 && this.taskList.every(t => t.checked)
        })
      } else {
        this.taskList = []
        this.allTask = false
      }
    },
    selectAllTask(val) {
      this.taskList.forEach(task => {
        task.checked = val
      })
      // 如果全选，将当前资源的所有任务添加到 selectedTasks
      if (val) {
        this.taskList.forEach(task => {
          const exists = this.selectedTasks.some(selected => selected.id === task.id)
          if (!exists) {
            this.selectedTasks.push(task)
          }
        })
      } else {
        // 如果取消全选，从 selectedTasks 中移除当前资源的任务
        this.selectedTasks = this.selectedTasks.filter(selected => {
          const isInCurrentResource = this.taskList.some(task => task.id === selected.id)
          return !isInCurrentResource
        })
      }
    },
    selectTask(index) {
      const task = this.taskList[index]
      if (task.checked) {
        // 选中时，添加到 selectedTasks
        const exists = this.selectedTasks.some(selected => selected.id === task.id)
        if (!exists) {
          this.selectedTasks.push(task)
        }
      } else {
        // 取消选中时，从 selectedTasks 中移除
        this.selectedTasks = this.selectedTasks.filter(selected => selected.id !== task.id)
      }
      // 更新全选状态
      this.allTask = this.taskList.length > 0 && this.taskList.every(t => t.checked)
    },
    nextStep() {
      const newSelectedTasks = this.taskList.filter(task => task.checked)
      // 叠加选中的任务，避免重复（根据 id 判断）
      newSelectedTasks.forEach(newTask => {
        const exists = this.selectedTasks.some(selectedTask => selectedTask.id === newTask.id)
        if (!exists) {
          this.selectedTasks.push(newTask)
        }
      })
      this.importStep = 2
    },
    prevStep() {
      // 返回第一步时，重置第一步的状态，但不清空已选中的任务
      this.currentResource = null
      this.taskList = []
      this.allTask = false
      this.importStep = 1
    },
    removeSelectedTask(index) {
      const removedTask = this.selectedTasks[index]
      this.selectedTasks.splice(index, 1)
      // 同步更新 taskList 中的 checked 状态
      if (removedTask) {
        const taskInList = this.taskList.find(t => t.id === removedTask.id)
        if (taskInList) {
          taskInList.checked = false
        }
      }
    },
    editTask(item, task_index) {
      this.selectTaskIndex = task_index
      this.showTaskContent = true
      this.taskContent = {
        question: item.question || '',
        answer: item.answer || '',
        questionIntent: item.questionIntent || '',
        answerIntent: item.answerIntent || '',
        checkList: item.checkPoints && item.checkPoints.length > 0 ? [...item.checkPoints] : ['']
      }
    },
    addCheckPoint() {
      this.taskContent.checkList.push('')
    },
    confirmImport() {
      // 保存编辑的内容到 selectedTasks
      if (this.showTaskContent && this.selectTaskIndex >= 0 && this.selectTaskIndex < this.selectedTasks.length) {
        const updatedTask = {
          ...this.selectedTasks[this.selectTaskIndex],
          question: this.taskContent.question,
          answer: this.taskContent.answer,
          questionIntent: this.taskContent.questionIntent,
          answerIntent: this.taskContent.answerIntent,
          checkList: this.taskContent.checkList.filter(item => item.trim())
        }
        this.selectedTasks[this.selectTaskIndex] = updatedTask
      }
      // 构建批量导入的入参
      const params = {
        storyId: this.storyId,
        storyQas: this.selectedTasks.map(task => ({
          id: 0,
          storyId: this.storyId,
          question: task.question || '',
          answer: task.answer || '',
          questionIntent: task.questionIntent || '',
          answerIntent: task.answerIntent || '',
          checkPoints: task.checkPoints && task.checkPoints.length > 0 ? task.checkPoints.filter(item => item.trim()) : [],
          createTime: '',
          updateTime: ''
        }))
      }
      storyqaBatchAdd(params).then(() => {
        this.$message({
          type: 'success',
          message: `成功导入${params.storyQas.length}个问题`,
          duration: 2 * 1000
        })
        this.importDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '导入失败',
          duration: 2 * 1000
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-table{
    overflow: auto;
  }
  .el-button {
    margin-left: 0;
    padding: 10px 18px;
    margin-right: 20px;
    &:focus, &:hover{
      background: #FFF;
      border: 1px solid #DCDFE6;
      color: #606266;
    }
  }
  .el-button:last-child{
    margin-right: 0;
    color: #FFF;
    background-color: #409EFF;
  }
}
.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background: #fff;
}
.search-left {
  display: flex;
  align-items: center;
}
.search-label {
  width: 100px;
  text-align: right;
  padding-right: 10px;
  font-weight: 500;
}
.search-input {
  width: 300px;
}
.search-right {
  display: flex;
  align-items: center;
}
.query-btn {
  margin-right: 10px;
}
.custom-dialog {
  width: 100%;
  height: 60vh;
  overflow: auto;
  padding: 20px;

  .el-form {
    display: block !important;

    .el-form-item {
      display: block !important;
      margin-bottom: 20px !important;
      width: 100%;

      .el-form-item__label {
        display: block !important;
        width: 100% !important;
        text-align: left !important;
        padding-bottom: 8px;
      }

      .el-form-item__content {
        display: block !important;
        margin-left: 0 !important;
        width: 100%;
      }
    }
  }

  .task-check {
    width: 100%;
    display: flex;
    margin-top: 20px;

    .check-name {
      color: #606266;
      font-weight: 600;
      width: 100px;
      text-align: end;
      padding-right: 10px;
      line-height: 40px;

      &::before {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
      }
    }

    .el-icon-circle-plus-outline {
      font-size: 20px;
      color: green;
      margin: 0 10px;
    }

    .el-icon-remove-outline {
      font-size: 20px;
      color: red;
    }

    .custom-check {
      width: 80%;

      div {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }
    }
  }
}
.custom-btn {
  width: 100%;
  height: 5vh;
  display: flex;
  justify-content: end;
  align-items: center;
  padding-right: 20px;
}
.custom-btn .el-button {
  margin-left: 10px;
}
/* 导入弹窗样式 */
.mode-dialog {
  padding: 20px;
}
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.item-name {
  width: 100px;
  text-align: right;
  padding-right: 10px;
  font-weight: 500;
}
.task-select {
  margin-left: 100px;
}
.dialog-content {
  margin-top: 20px;
  max-height: 400px;
  overflow: auto;
}
.mode-content {
  margin-top: 20px;
}
.tast-detail {
  padding: 15px;
  background: #fafafa;
  border-radius: 4px;
}
.question-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.content-item {
  flex: 1;
}
.content-item.text {
  margin-right: 20px;
}
.check-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.check-list > div:first-child {
  margin-right: 10px;
}
.check-list span {
  background: #ecf5ff;
  color: #409eff;
  padding: 4px 12px;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e4e7ed;
}
.dialog-footer .el-button {
  margin-left: 10px;
}
.select-list {
  max-height: 300px;
  overflow: auto;
}
.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #e4e7ed;
  cursor: pointer;
  &:hover {
    background: #f5f7fa;
  }
}
.close-icon {
  color: #999;
  &:hover {
    color: #f56c6c;
  }
}
.task-margin {
  margin-top: 20px;
}
.task-margin .el-form {
  display: block !important;
  .el-form-item {
    display: block !important;
    margin-bottom: 20px !important;
    width: 100%;
    .el-form-item__label {
      display: block !important;
      width: 100% !important;
      text-align: left !important;
      padding-bottom: 8px;
    }
    .el-form-item__content {
      display: block !important;
      margin-left: 0 !important;
      width: 100%;
    }
  }
}
.task-margin .task-check {
  width: 100%;
  display: flex;
  margin-top: 20px;
  .check-name {
    color: #606266;
    font-weight: 600;
    width: 100px;
    text-align: end;
    padding-right: 10px;
    line-height: 40px;
  }
  .el-icon-circle-plus-outline {
    font-size: 20px;
    color: green;
    margin: 0 10px;
  }
  .el-icon-remove-outline {
    font-size: 20px;
    color: red;
  }
  .custom-check {
    width: 80%;
    div {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}
</style>
